<template>
    <v-card class="mx-auto" max-width="95%" style="margin-top: 10px;">
      <div @click="expande()">
        <v-img v-bind:src="data.img" height="110px"></v-img>
        <div class="float-right text-right" style="padding: 2px 10px 0px 0px">
          <div class="text-caption text--disabled">Bilheteria R$ {{ data.valorOriginal | fmtNumber }}</div>
          <div class="font-weight-black">R$ {{ data.valorPromo | fmtNumber }}</div>
        </div>
        <div class="text-subtitle-1 font-weight-black" style="padding: 10px">{{ data.titulo }}</div>
      </div>
      <v-expand-transition @click.prevent="show != show">
        <div v-show="show">
          <v-card-text>
            <div v-html="data.texto">
            </div>
            <div class="float-right">
              <span>Quantidade</span>
              <v-btn class="cyan darken-2 white--text" fab x-small style="margin: 10px" @click="quantidade--">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <span style="width: 30px">{{quantidade}}</span>
              <v-btn class="cyan darken-2 white--text" fab x-small style="margin: 10px" @click="quantidade++">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <span class="font-weight-black">Total: {{ total | fmtNumber}}</span>
            </div>
          </v-card-text>
          <v-btn class="cyan darken-2 white--text" block style="margin-top: 10px" @click="addToCart()">Adicionar ao carrinho</v-btn>
        </div>
      </v-expand-transition>
    </v-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'DetalhePassaporte',
  props: ['data'],
  data: () => ({
    show: false,
    quantidade: 1
  }),
  computed: {
    total: function () {
      return this.data.valorPromo * this.quantidade
    }
  },
  mounted () {
    window.scrollTo({
      top: 650,
      behavior: 'smooth'
    })
  },
  methods: {
    ...mapActions(['updateCarrinho']),
    expande: function () {
      this.show = !this.show
      setTimeout(() => {
        window.scrollTo({
          top: 650,
          behavior: 'smooth'
        })
      }, 300)
    },
    addToCart: function () {
      const data = this.data
      data.quantidade = this.quantidade
      data.valor = data.valorPromo
      this.updateCarrinho(data)
      this.show = false
      window.scrollTo({
        top: 650,
        behavior: 'smooth'
      })
    }
  }
}
</script>
